
/*
    A component consisting of two or three dropdowns representing a time of day,
    handling changing values and formatting
*/

import React from "react";

// create constant lists of the hour/minute values to fill up the dropdowns
const hours = [...Array(24).keys()].map(v => String(v).padStart(2,"0"));
const minutes = [...Array(60).keys()].map(v => String(v).padStart(2,"0"));
const shortHours = [...Array(11).keys()].map(v => String(v+1).padStart(2,"0"));
shortHours.push("00");

/*
PROPS:
    - name
    - value
    - onChange()
    - disabled
    - nonMilitary
*/

const TimeInput = (props) => {

    let [hourProp, minuteProp] = props.value ? props.value.split(":") : ["00", "00"];

    let isPM = hourProp >= 12;

    console.log("TIME INPUT", hourProp, minuteProp);

    // pull out the AM/PM if it's there
    if(minuteProp.includes(" ")){
        const split = minuteProp.split(" ");
        minuteProp = split[0];

        console.log("time input minute split here", split, (split[1].toLowerCase() == "pm" || split[1].toLowerCase() == "p"), (split[1].toLowerCase() == "am" || split[1].toLowerCase() == "a"));

        if(split[1].toLowerCase() == "pm" || split[1].toLowerCase() == "p"){
            isPM = true;
            hourProp = parseInt(hourProp) + 12;
        }
        else if(split[1].toLowerCase() == "am" || split[1].toLowerCase() == "a"){
            isPM = false;
        }
    }

    const hoursToUse = props.nonMilitary ? shortHours : hours;

    const updateHour = (evt) => {
        const hourVal = parseInt(evt.target.value);
        const newHour = (((isPM && props.nonMilitary) ? hourVal + 12 : hourVal)+"").padStart(2, "0");

        // make this look like a normal control's event from the outside
        props.onChange({target: {name:props.name, value: `${newHour}:${minuteProp}`}});
    }

    // switch between AM & PM for non-military time
    const toggleHour = (evt) => {
        const prevHour = parseInt(hourProp);
        const newHour = ((prevHour < 12 ? prevHour + 12 : prevHour - 12)+"").padStart(2, "0");
        props.onChange({target: {name:props.name, value: `${newHour}:${minuteProp}`}});
    }

    const updateMinute = (evt) => {
        // make this look like a normal control's event from the outside
        props.onChange({target: {name:props.name, value: `${(!isPM && hourProp === "12") ? "00" : hourProp}:${evt.target.value}`}});
    }

    const hourValueForDropDown = props.nonMilitary ? ((hourProp % 12)+"").padStart(2,"0") : (hourProp + "").padStart(2, "0");

    console.log("HOUR VALUE FOR DROPDOWN", hourValueForDropDown, props.nonMilitary);

    return (
        <div className="time-input" style={{
            display:"inline-block"
        }}>
            <select 
                value={hourValueForDropDown} 
                onChange={updateHour} 
                disabled={props.disabled ? "disabled": ""}                
            >
            {
                hoursToUse.map((hour, index) => {
                    return <option key={index} value={hour}>
                        {
                            props.nonMilitary && hour === "00"
                            ? "12"
                            : hour
                        }
                    </option>
                })
            }
            </select>
            <span style={{padding: "0 4px"}}>:</span>
            <select 
                value={minuteProp} 
                onChange={updateMinute} 
                disabled={props.disabled ? "disabled": ""}
            >
            {
                minutes.map((minute, index) => {
                    return <option key={index} value={minute}>{minute}</option>
                })
            }
            </select>
            {
                props.nonMilitary
                ? <>
                    <span style={{padding: "0 4px"}}></span>
                    <select 
                        value={isPM ? "1" : "0"} 
                        onChange={toggleHour} 
                        disabled={props.disabled ? "disabled": ""}
                    >
                        <option value="0">AM</option>
                        <option value="1">PM</option>
                    </select>
                </>
                : null
            }
        </div>
    )
};

export default TimeInput;